// External libraries
import { useEffect, useMemo, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { useNavigate } from 'react-router-dom';

// Third-party components
import {
  MaterialReactTable,
  useMaterialReactTable,
  createMRTColumnHelper,
  MRT_Row
} from 'material-react-table';

// MUI components and icons
import {
  Box,
  Button,
  ListItemIcon,
  MenuItem,
  Typography,
  lighten,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

// Project interfaces and helpers
import { ApiResponse } from '../../../interface/IResponse';
import { LoanReportTableData, PdfDownloadOutput } from '../../../interface/ILoanReport';
import helper from '../../../helpers/index';
import loanReportService from '../../../pages/Loan/loanReportService';

// Assets
import iconView from '../../../assets/visible.png';
import iconEdit from '../../../assets/edit-icon.png';
import iconDelete from '../../../assets/delete.png';


const columnHelper = createMRTColumnHelper<LoanReportTableData>();

interface LoanAmortizationTableProps {
  data: LoanReportTableData[];
}



const LoanReportTable: React.FC<LoanAmortizationTableProps> = ({ data }) => {





  async function downloadPdf(){
    try
    {

      var response:AxiosResponse<ApiResponse<PdfDownloadOutput>>  = await loanReportService.generateHtmlReport();

      var result = response.data.result;

      downloadBase64File('application/pdf', result.fileContents, result.fileDownloadName);


    }
    catch(err){
      console.log('downloadPdf:: ', err);

    }
    finally
    {


    }
  }

  function downloadBase64File(contentType:string, base64Data:string, fileName:string) {
      const linkSource = `data:${contentType};base64,${base64Data}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
  }


  const columns = [
    { accessorKey: 'department', header: 'Department' },
    { accessorKey: 'name', header: 'Name' },
    { accessorKey: 'principal', header: 'Principal' },
    { accessorKey: 'dateGranted', header: 'Date Granted' },
    { accessorKey: 'terms', header: 'Terms' },
    {
      header: 'Outstanding Balances',
      columns: [
        { accessorKey: 'regularLoan', header: 'Regular Loan' },
        { accessorKey: 'w2sSalaryEmergency', header: 'W2S-Salary & Emergency' },
        { accessorKey: 'swel', header: 'SWEL' },
        { accessorKey: 'covid', header: 'Covid' },
        { accessorKey: 'gadget', header: 'Gadget' },
      ],
    },
    {
      header: 'Current',
      columns: [{ accessorKey: 'current', header: 'Current' }],
    },
    {
      header: 'Missed',
      columns: [
        { accessorKey: 'missed_1_30', header: '1-30 days' },
        { accessorKey: 'missed_31_60', header: '31-60 days' },
        { accessorKey: 'missed_61_90', header: '61-90 days' },
        { accessorKey: 'missed_91_above', header: '91 days above' },
      ],
    },
    {
      header: 'Past Due',
      columns: [
        { accessorKey: 'past_due_1_30', header: '1-30 days' },
        { accessorKey: 'past_due_31_360', header: '31-360 days' },
        { accessorKey: 'past_due_361_above', header: '361 days above' },
      ],
    },
  ];


  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnActions: false,
    muiTablePaperProps: {
      elevation: 1,
      sx: {
        boxShadow: 'none',
        width: '100%',
        background: 'transparent',
        display: 'grid',

      }
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
      sx={{
        display: 'flex',
        gap: '16px',
        padding: '8px',
        flexWrap: 'wrap',
      }}
    >

      <Button
        disabled={table.getPrePaginationRowModel().rows.length === 0}
        onClick={async () =>
          await downloadPdf()
        }
        startIcon={<FileDownloadIcon />}
      >
        Export All Rows
      </Button>
    </Box>
    )
  });

  return <MaterialReactTable table={table} />;

};




export default LoanReportTable;